module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/delete/autoDelete')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsSystem.deletedays),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsSystem, "deletedays", $$v)
      },
      expression: "getSettingsSystem.deletedays"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/delete/Disable'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/delete/week'),
      "value": "7 days"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '2 ' + _vm.$l('settings/delete/week'),
      "value": "14 days"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/delete/month'),
      "value": "1 month"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '2 ' + _vm.$l('settings/delete/month'),
      "value": "2 month"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '6 ' + _vm.$l('settings/delete/month'),
      "value": "6 month"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '12 ' + _vm.$l('settings/delete/month'),
      "value": "1 year"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/delete/Manual delete')
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.form.ManualDelete.From),
      callback: function($$v) {
        _vm.$set(_vm.form.ManualDelete, "From", $$v)
      },
      expression: "form.ManualDelete.From"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.form.ManualDelete.To),
      callback: function($$v) {
        _vm.$set(_vm.form.ManualDelete, "To", $$v)
      },
      expression: "form.ManualDelete.To"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/delete/autoCompress')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsSystem.compressdays),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsSystem, "compressdays", $$v)
      },
      expression: "getSettingsSystem.compressdays"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/delete/Disable'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/delete/week'),
      "value": "7 days"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '2 ' + _vm.$l('settings/delete/week'),
      "value": "14 days"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '1 ' + _vm.$l('settings/delete/month'),
      "value": "1 month"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '2 ' + _vm.$l('settings/delete/month'),
      "value": "2 month"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '6 ' + _vm.$l('settings/delete/month'),
      "value": "6 month"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": '12 ' + _vm.$l('settings/delete/month'),
      "value": "1 year"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full"
  }, [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "loading": _vm.deleteLoading,
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$l('settings/delete/Delete')))])], 1)], 1)], 1), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": _vm.$l('settings/delete/Values')
    }
  }, [_c('el-row', _vm._l((_vm.getSettingsSystem.delvalsel), function(item) {
    return _c('el-col', {
      key: item.name,
      attrs: {
        "md": 12,
        "lg": 8
      }
    }, [_c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!(item.name == 'logs' && !_vm.getSettingsAddons.logs)),
        expression: "!(item.name == 'logs' && !getSettingsAddons.logs)"
      }],
      staticClass: "el-form-item-full",
      attrs: {
        "label": _vm.$l('settings/delete/' + item.name)
      }
    }, [_c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": ""
      },
      model: {
        value: (item.enabled),
        callback: function($$v) {
          _vm.$set(item, "enabled", $$v)
        },
        expression: "item.enabled"
      }
    })], 1)], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50179dc7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/Delete.vue
// module id = 457
// module chunks = 1